module.exports = __webpack_public_path__ + "Fram410-72403d54.webp";